import { Button } from "@/components/ui/button";
import { Users, Check } from "lucide-react";
import { useEventRsvp } from "@/hooks/useEventRsvp";
import { cn } from "@/lib/utils";

interface RsvpButtonProps {
  eventId: string;
  occurrenceDate: string; // YYYY-MM-DD (local)
  memberId: string | null;
  size?: "sm" | "default";
  className?: string;
}

const RsvpButton = ({
  eventId,
  occurrenceDate,
  memberId,
  size = "sm",
  className,
}: RsvpButtonProps) => {
  const { count, isGoing, loading, toggling, toggle } = useEventRsvp(
    { eventId, occurrenceDate },
    memberId
  );

  // Public (not logged in / not a member): show count only
  if (!memberId) {
    return (
      <div
        className={cn(
          "inline-flex items-center gap-1.5 text-sm text-muted-foreground",
          className
        )}
      >
        <Users className="h-4 w-4" />
        <span>
          {loading ? "—" : count} {count === 1 ? "person" : "people"} going
        </span>
      </div>
    );
  }

  return (
    <Button
      variant={isGoing ? "default" : "outline"}
      size={size}
      onClick={toggle}
      disabled={toggling || loading}
      className={cn("gap-2", className)}
    >
      {isGoing ? <Check className="h-4 w-4" /> : <Users className="h-4 w-4" />}
      {isGoing ? "I'm going" : "RSVP"}
      <span
        className={cn(
          "ml-1 rounded-full px-2 py-0.5 text-xs",
          isGoing
            ? "bg-primary-foreground/20 text-primary-foreground"
            : "bg-muted text-muted-foreground"
        )}
      >
        {count}
      </span>
    </Button>
  );
};

export default RsvpButton;
